// extracted by mini-css-extract-plugin
export default {"body":"block-form-dialog_body__7svG1"};